module.exports = __webpack_public_path__ + "static/media/education.9c9ecad1.png";